import { useLayoutIsXS } from '@segments/Responsive/client'
import * as React from 'react'

import {
  ProductList,
  useProductListCountCtx,
  useProductListDataCtx,
} from '~shared/segments/ProductList'

import { menuScreenLayoutSettings } from '../config/menuScreenLayoutSettings'
import { MenuCart } from './MenuCart'
import { MobileMenuScreenContainer } from './MobileMenuScreenContainer'
import { TabletMenuScreenContainer } from './TabletMenuScreenContainer'

type TProps = NoChildren

const { productPadding } = menuScreenLayoutSettings

/**
 * The content of the menu screen.
 */
export const MenuScreenResponsiveContent: React.FC<TProps> = () => {
  const isMobile = useLayoutIsXS()
  const categories = useProductListDataCtx()
  const productCategoryCount = useProductListCountCtx()

  const MenuScreenContainer = React.useMemo(
    () => (isMobile ? MobileMenuScreenContainer : TabletMenuScreenContainer),
    [isMobile],
  )

  const isLoading = !categories
  const hasMultipleCategories = Boolean(productCategoryCount !== null && productCategoryCount > 1)
  const shouldRenderCategoryNav = isLoading || hasMultipleCategories

  return (
    <MenuScreenContainer //
      cart={<MenuCart />}
      shouldRenderCategoryNav={shouldRenderCategoryNav}
    >
      <ProductList
        isMobile={isMobile}
        productPadding={productPadding}
        productCategories={categories}
      />
    </MenuScreenContainer>
  )
}
